import ChangePasswordForm from "./ChangePasswordForm"

export default  ChangePasswordForm;



// WEBPACK FOOTER //
// ./src/components/App/ChangePassword/ChangePasswordForm/index.js